import axios from 'axios';

export default class API {
  constructor(endpoint) {
    this.endpoint = endpoint;
  }

  async call(method, path, config = null) {
    const axiosConfig = {
      method,
      url: this.endpoint + path,
      headers: {
        Authorization: 'Bearer secret', // TODO: accessToken?
      },
    };
    if (config !== null) {
      // this can override existing values in axios_config
      Object.assign(axiosConfig, config);
    }
    return axios(axiosConfig);
  }
}
